module.exports = __webpack_public_path__ + "startpage-logged-out-b8bc31fe/Background_04_7x2_a-6b12076450b881f24ec1dc7b6f094f16.svg";